import React from 'react';
import css from './SectionRobot.module.css';
import robotImg from './robot.png';
import { useHistory } from 'react-router-dom';

const SectionRobot = () => {
  const history = useHistory();
  return (
    <div className={css.wrapper}>
      <div className={css.box}>
        <img className={css.robotImage} src={robotImg} />
        <div className={css.textWrapper}>
          <p className={css.title}>
            Let's shape the future of 3d— <br />
            together.
          </p>
          <p className={css.description}>
            Join ScanWow. Buy scans. Sell scans. Start something big.
          </p>
        </div>
      </div>

      <div className={css.buttonsWrapper}>
        <button
          type="button"
          onClick={() => history.push('/become-creator')}
          className={css.quickActionButton}
        >
          <span>Become A Creator</span>
        </button>

        <button type="button" onClick={() => history.push('/s')} className={css.quickActionButton}>
          <span>Browse Scans</span>
        </button>

        <button
          type="button"
          onClick={() =>
            typeof window !== 'undefined' && (window.location.href = '/static/docs/howto.pdf')
          }
          className={css.quickActionButton}
        >
          <span>Download the guide</span>
        </button>
      </div>
    </div>
  );
};

export default SectionRobot;
